var _path, _rect, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.53353C6.13181 8.53353 5.83333 8.83201 5.83333 9.2002V17.2002C5.83333 17.5684 6.13181 17.8669 6.5 17.8669H18.5C18.8682 17.8669 19.1667 17.5684 19.1667 17.2002V9.2002C19.1667 8.83201 18.8682 8.53353 18.5 8.53353H6.5ZM4.5 9.2002C4.5 8.09563 5.39543 7.2002 6.5 7.2002H18.5C19.6046 7.2002 20.5 8.09563 20.5 9.2002V17.2002C20.5 18.3048 19.6046 19.2002 18.5 19.2002H6.5C5.39543 19.2002 4.5 18.3048 4.5 17.2002V9.2002Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.1001,
    y: 8,
    width: 10.4,
    height: 1.6,
    transform: "rotate(90 10.1001 8)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4681_1654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 15,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.7998H18.9V7.9998H12.7286L4.5 9.5998V4.7998Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4681_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49024 6.13314C6.12385 6.13314 5.82683 6.43161 5.82683 6.7998V14.7998C5.82683 15.168 6.12385 15.4665 6.49024 15.4665H16.1098C16.4761 15.4665 16.7732 15.168 16.7732 14.7998V6.7998C16.7732 6.43161 16.4761 6.13314 16.1098 6.13314H6.49024ZM4.5 6.7998C4.5 5.69524 5.39106 4.7998 6.49024 4.7998H16.1098C17.2089 4.7998 18.1 5.69524 18.1 6.7998V14.7998C18.1 15.9044 17.2089 16.7998 16.1098 16.7998H6.49024C5.39106 16.7998 4.5 15.9044 4.5 14.7998V6.7998Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.011d2c39d6a984a8594ff61096337d92.svg";
export { ForwardRef as ReactComponent };